import { Component, inject } from '@angular/core';
import { DataPreloaderService } from './core/services/data-preloader.service';
import { RouterOutlet } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { UserService } from './core/services/user/user.service';
import { SummerService } from './page/promo/summer/summer.service';
import { ArabicService } from './core/services/arabic.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {
  public loader = inject(DataPreloaderService);
  private _user = inject(UserService);
  private _summer = inject(SummerService);
  private _arabic = inject(ArabicService);


  title = 'Spin Samurai';

  constructor() {
    if (!this._arabic.isAr) {
      this._initSummerPromo();
    }
  }

  private _initSummerPromo() {
    this._user.auth$.pipe(switchMap(() => this._summer.initPromo$())).subscribe();
  }
}
